import React, { useMemo } from 'react'

import './AdminHeaderBar.scss'

import iconChat from '../../Assets/Icon/AdminDashboard/mn9vyk13-q3spn24.svg'
import iconBell from '../../Assets/Icon/AdminDashboard/mn9vyk13-qmmfwbe.svg'

type Props = {
  title: string
}

function ordinal(n: number) {
  const mod100 = n % 100
  if (mod100 >= 11 && mod100 <= 13) return `${n}th`
  switch (n % 10) {
    case 1:
      return `${n}st`
    case 2:
      return `${n}nd`
    case 3:
      return `${n}rd`
    default:
      return `${n}th`
  }
}

const AdminHeaderBar: React.FC<Props> = ({ title }) => {
  const dateLabel = useMemo(() => {
    const d = new Date()
    const weekday = new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(d)
    const month = new Intl.DateTimeFormat('en-US', { month: 'long' }).format(d)
    return `${weekday} ${ordinal(d.getDate())} ${month}, ${d.getFullYear()}`
  }, [])

  return (
    <header className='blockchain-admin-header'>
      <div className='admin-header__left'>
        <button
          type='button'
          className='admin-header__menu-button'
          data-bs-toggle='offcanvas'
          data-bs-target='#adminSidebarOffcanvas'
          aria-controls='adminSidebarOffcanvas'
          aria-label='Open sidebar'
        >
          <span />
          <span />
          <span />
        </button>
        <div className='admin-header__title'>{title}</div>
      </div>

      <div className='admin-header__right'>
        <div className='admin-header__date'>{dateLabel}</div>
        <button type='button' className='admin-header__icon-button' aria-label='Messages'>
          <span className='admin-header__icon' style={{ backgroundImage: `url(${iconChat})` }} />
          <span className='admin-header__dot' />
        </button>
        <button type='button' className='admin-header__icon-button' aria-label='Notifications'>
          <span className='admin-header__icon' style={{ backgroundImage: `url(${iconBell})` }} />
          <span className='admin-header__dot' />
        </button>
      </div>
    </header>
  )
}

export default AdminHeaderBar
